import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[appResponsiveImage]'
})
export class ResponsiveImageDirective {
    @Input() sizes?: string;

    private defaultSizes =
        "(min-width: 1340px) 611px, (min-width: 780px) calc(43.52vw + 39px), (min-width: 440px) 350px, 83.33vw";

    private currentAppliedSrc?: string;

    constructor(private el: ElementRef<HTMLImageElement>, private renderer: Renderer2) {}

    @Input('appResponsiveImage')
    set imagePath(value: string | null | undefined) {
        if (!value) {
            return;
        }

        const isDirect = value.startsWith('http') || value.startsWith('/');
        const finalSrc = isDirect ? value : `/assets/images/${value}-800.webp`;

        if (this.currentAppliedSrc === finalSrc) {
            return;
        }

        if (!isDirect) {
            const baseUrl = `/assets/images/${value}`;
            const srcSet = `
        ${baseUrl}-400.webp 400w,
        ${baseUrl}-800.webp 800w,
        ${baseUrl}-1200.webp 1200w
      `.trim();

            this.renderer.setAttribute(this.el.nativeElement, 'srcset', srcSet);
            this.renderer.setAttribute(this.el.nativeElement, 'sizes', this.sizes || this.defaultSizes);
            this.renderer.setAttribute(this.el.nativeElement, 'src', finalSrc);
            this.currentAppliedSrc = finalSrc
            return;
        }

        const preloader = new Image();
        preloader.onload = () => {
            if (this.currentAppliedSrc === finalSrc) return;
            this.renderer.removeAttribute(this.el.nativeElement, 'srcset');
            this.renderer.removeAttribute(this.el.nativeElement, 'sizes');
            this.renderer.setAttribute(this.el.nativeElement, 'src', finalSrc);
            this.currentAppliedSrc = finalSrc
        };

        preloader.onerror = () => {
            console.warn('Failed to load hero image:', finalSrc);
        };

        preloader.src = finalSrc;
    }
}
